// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "common" + "." + "2ba05a68c244c1ce" + ".css";
};